module.exports = __webpack_public_path__ + "static/img/item-6-1-big.0810d75.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sustainable/innovation/item-6-1-big.png
// module id = 1/ar
// module chunks = 2